import { tv } from "tailwind-variants";

/** Dropdown menu styles intended to be used with React Aria-based components. */
export const dropdownMenu = tv({
  slots: {
    popover:
      "min-w-(--trigger-width) overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 transition data-[entering]:scale-95 data-[entering]:opacity-0 data-[entering]:duration-150 data-[exiting]:scale-95 data-[exiting]:opacity-0 data-[exiting]:duration-75",
    menu: "p-1",
    item: "group cursor-pointer rounded-md px-2 py-1.5 text-sm text-foreground hover:bg-muted focus:bg-muted data-[focused]:bg-muted",
  },
});
